/* =====================================================================
   BundleAddonCore — pure helpers + line store for bundle add-ons
   =====================================================================
   No DOM. Shared by bundle-accessory-selector.js and bundle-cable-selector.js.
   Dual export: window.BundleAddonCore (browser) + module.exports (node tests).
   Line shape: { id:Number, quantity:Number, price:Number(cents), label:String }
   ===================================================================== */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.BundleAddonCore = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function indexOfId(lines, id) {
    for (var i = 0; i < lines.length; i++) { if (lines[i].id === id) return i; }
    return -1;
  }

  function cloneLine(line) {
    return { id: line.id, quantity: line.quantity, price: line.price, label: line.label };
  }

  // Replace the quantity for `line.id` (no accumulate). quantity<=0 removes it.
  function upsertLine(lines, line) {
    var out = lines.slice();
    var idx = indexOfId(out, line.id);
    if (line.quantity <= 0) {
      if (idx !== -1) out.splice(idx, 1);
      return out;
    }
    if (idx === -1) out.push(cloneLine(line));
    else out[idx] = cloneLine(line);
    return out;
  }

  // Accumulate quantity onto an existing `line.id` (or add a new line).
  function mergeLine(lines, line) {
    var out = lines.slice();
    var idx = indexOfId(out, line.id);
    if (idx === -1) { out.push(cloneLine(line)); return out; }
    var merged = cloneLine(out[idx]);
    merged.quantity = out[idx].quantity + line.quantity;
    out[idx] = merged;
    return out;
  }

  function removeLine(lines, id) {
    return lines.filter(function (l) { return l.id !== id; });
  }

  function computeTotal(lines) {
    return lines.reduce(function (sum, l) { return sum + l.price * l.quantity; }, 0);
  }

  function toCartItems(lines) {
    return lines.map(function (l) { return { id: l.id, quantity: l.quantity }; });
  }

  function AddonLineStore(onChange) {
    this.lines = [];
    this._onChange = typeof onChange === 'function' ? onChange : function () {};
  }
  AddonLineStore.prototype.upsert = function (line) { this.lines = upsertLine(this.lines, line); this._onChange(); };
  AddonLineStore.prototype.merge = function (line) { this.lines = mergeLine(this.lines, line); this._onChange(); };
  AddonLineStore.prototype.remove = function (id) { this.lines = removeLine(this.lines, id); this._onChange(); };
  AddonLineStore.prototype.clear = function () { if (!this.lines.length) return; this.lines = []; this._onChange(); };
  AddonLineStore.prototype.getLines = function () { return this.lines.map(cloneLine); };
  AddonLineStore.prototype.getTotal = function () { return computeTotal(this.lines); };
  AddonLineStore.prototype.getCartItems = function () { return toCartItems(this.lines); };
  AddonLineStore.prototype.has = function (id) { return indexOfId(this.lines, id) !== -1; };
  AddonLineStore.prototype.getQty = function (id) { var i = indexOfId(this.lines, id); return i === -1 ? 0 : this.lines[i].quantity; };

  return {
    upsertLine: upsertLine,
    mergeLine: mergeLine,
    removeLine: removeLine,
    computeTotal: computeTotal,
    toCartItems: toCartItems,
    AddonLineStore: AddonLineStore
  };
});
